import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpService } from './http.service';
import { environment } from '../../environments/environment';
import { tap } from 'rxjs/operators';

/**
 * Структура на JSON-а в DB-то. Свободен формат, разширяваме при нужда.
 */
export interface UserPrefs {
	cases?: {
		visibleColumns?: string[];   // имената на колоните в caseColumns
		pageSize?: number;
		previewPaneOpen?: boolean;
	};
	ui?: {
		// Колко пъти сме показали warning-а 'Внимание приключено дело'
		// ЗА ВСЯКО ОТДЕЛНО ДЕЛО (ключ = lawsuiteId). След 2-рия път за
		// дадено дело не го показваме повече за него.
		prikljuchenoWarningSeen?: { [lawsuiteId: string]: number };
	};
	// Може да се добавят и други екрани в бъдеще
}

@Injectable({ providedIn: 'root' })
export class UserPreferencesService {

	private readonly baseUrl = environment.serviceBaseUrl + '/api/user-preferences';

	// Cached / реактивни prefs — компоненти се абонират и реагират на промени.
	private prefsSubject = new BehaviorSubject<UserPrefs>({});
	prefs$ = this.prefsSubject.asObservable();

	constructor(private http: HttpService) { }

	/** Зарежда prefs-те от сървъра. Извиква се при login (или ngOnInit). */
	load(): Observable<UserPrefs> {
		return this.http.get<{ preferences: string }>(this.baseUrl).pipe(
			tap(resp => {
				const parsed = this.parse(resp && resp.preferences);
				this.prefsSubject.next(parsed);
			})
		) as any as Observable<UserPrefs>;
	}

	/** Записва нова версия на prefs-те. Patch-style: сливаме с текущите. */
	patch(patch: Partial<UserPrefs>): Observable<UserPrefs> {
		const current = this.prefsSubject.value || {};
		const merged: UserPrefs = {
			...current,
			...patch,
			cases: { ...(current.cases || {}), ...(patch.cases || {}) },
			ui:    { ...(current.ui    || {}), ...(patch.ui    || {}) }
		};
		return this.save(merged);
	}

	/** Запазва изцяло, replace-ва старите prefs. */
	save(prefs: UserPrefs): Observable<UserPrefs> {
		const body = { preferences: JSON.stringify(prefs) };
		return this.http.put<{ preferences: string }>(this.baseUrl, body).pipe(
			tap(resp => this.prefsSubject.next(this.parse(resp && resp.preferences)))
		) as any as Observable<UserPrefs>;
	}

	/** Текущите cached prefs (синхронно). */
	current(): UserPrefs {
		return this.prefsSubject.value || {};
	}

	private parse(json: string): UserPrefs {
		if (!json) return {};
		try {
			return JSON.parse(json);
		} catch (e) {
			return {};
		}
	}
}
